import { useLocation } from 'react-router-dom';
import { OrderType } from '../../types/types';

export function useQuery() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    return query;
}

export function useSalesType() {
    const query = useQuery();
    const salesType = query.get('salesType') || 'secondary';
    return salesType;
}

export function determineOrderType(url: string) {
    const hasPrimary = url.includes("createPrimaryOrder") || url.includes("purchase");  
    if (hasPrimary) {
      return OrderType.PRIMARY;
    } else {
      return OrderType.SECONDARY;
    } 
  }
  